/**
 * Programmatically open a file-picker dialog and invoke `onFile` with the
 * selected file. Avoids duplicating the hidden-input pattern throughout
 * the codebase.
 */
export function triggerFileInput(
  accept: string,
  onFile: (file: File) => void,
): void {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = accept;
  input.onchange = (event) => {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) onFile(file);
  };
  input.click();
}

/**
 * Remove a search param from the current URL and navigate with `replace`.
 */
export function cleanupSearchParam(
  searchParams: URLSearchParams,
  paramName: string,
  navigate: (to: string, opts?: { replace?: boolean }) => void,
  pathname: string,
): void {
  const next = new URLSearchParams(searchParams);
  next.delete(paramName);
  const qs = next.toString();
  navigate(`${pathname}${qs ? `?${qs}` : ''}`, { replace: true });
}
